import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import LogoHpa from './images/logo.png';
import TableComponent from './TableComponent';
import { loginUser } from '../utils/auth';
import './tasks.css';

const MgTasks = ({ socket }) => {
  const navigate = useNavigate();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errorMessages, setErrorMessages] = useState({});
  const [donnees, setDonnees] = useState([]);
  const [chargement, setChargement] = useState(true);
  const [erreur, setErreur] = useState(null);
  const [donneesFiltrees, setDonneesFiltrees] = useState([]);
  const [serviceSelectionne, setServiceSelectionne] = useState(null);

  const handleLogin = async (event) => {
    event.preventDefault();
    const uname = event.target.uname.value;
    const pass = event.target.pass.value;
    const result = await loginUser(uname, pass);
    if (result.success) {
      setIsSubmitted(true);
      setErrorMessages({});
    } else {
      setErrorMessages({ name: 'pass', message: result.message || 'Identifiants incorrects' });
    }
  };

  const renderError = () => (
    errorMessages.message && (
      <div className="message_erreur">{errorMessages.message}</div>
    )
  );

  const renderForm = (
    <div className="form">
      <form className="form_margin BC" onSubmit={handleLogin}>
        <br /><br />
        <label className="sous_titre">Utilisateur </label>
        <input className="utilisateur_interne" minLength={4} type="text" name="uname" required />
        {renderError()}
        <label className="sous_titre">Code d&apos;accès</label>
        <input className="utilisateur_interne" minLength={4} type="password" name="pass" required />
        <div className="ftt__footer BC">
          <button className="home__cta">Connexion</button>
        </div>
      </form>
    </div>
  );

  // Dans MgTasks.js, dans le useEffect
  useEffect(() => {
    if (socket) {
      const handleConnect = () => {
        console.log('✅ Tasks - Socket connecté');
        socket.emit('module_connected', { module: 'Tasks', socketId: socket.id });
      };
      
      socket.on('connect', handleConnect);
      
      if (socket.connected) {
        socket.emit('module_connected', { module: 'Tasks', socketId: socket.id });
      }
      
      return () => socket.off('connect', handleConnect);
    }
  }, [socket]);

  useEffect(() => {
    if (!isSubmitted) return;
    setChargement(true);
    socket.emit('recuperer_donnees', (response) => {
      if (response.success) {
        setDonnees(response.donnees);
        setErreur(null);
      } else {
        setErreur(response.error || "Erreur lors de la récupération des données");
        console.error("Erreur:", response.error);
      }
      setChargement(false);
    });
  }, [socket, isSubmitted]);

  // Fonction pour filtrer les colonnes à afficher
  const filtrerColonnes = (donnees, service) => {
    return donnees.map(item => {
      // Pour tous les services, on retire les colonnes sensibles
      const { jeton, numMedecin, numTigo, Remise, Dette, ...itemFiltre } = item;

      return itemFiltre;
    });
  };

  const afficherDonneesService = (service) => {
    // Filtre les données par le service exact passé en paramètre
    const donneesFiltreesParService = donnees.filter(item =>
      item.service === service
    );

    const donneesFiltreesColonnes = filtrerColonnes(donneesFiltreesParService, service);
    setDonneesFiltrees(donneesFiltreesColonnes);
    setServiceSelectionne(service);
  };

  const creerFichierJSON = (service) => {
    const donneesFiltreesParService = donnees.filter(item =>
      item.service === service
    );

    const donneesFiltreesColonnes = filtrerColonnes(donneesFiltreesParService, service);

    if (donneesFiltreesColonnes.length === 0) {
      alert(`Aucune donnée trouvée pour le service ${service}`);
      return;
    }

    const jsonData = JSON.stringify(donneesFiltreesColonnes, null, 2);
    const blob = new Blob([jsonData], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `journal_${service}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    socket.emit('sauvegarder_journal', { service, donnees: donneesFiltreesColonnes }, (response) => {
      if (response.success) {
        alert(`Journal ${service} créé avec succès!`);
      } else {
        alert("Erreur lors de la création du journal: " + response.error);
      }
    });
  };

  const retour = () => {
    navigate('/MgCaisse');
  };

  const retourSelection = () => {
    setServiceSelectionne(null);
    setDonneesFiltrees([]);
  };

  if (!isSubmitted) return renderForm;

  return (
    <>
      {/* Entête */}
      <div className="entete TC marges_logo_5px">
        <div className="marges_logo_5px">
          <img className='logo_clinique marges_logo_5px' src={LogoHpa} alt="LNE" id="logo" />
        </div>
        <div className='titre_entete'>
          <div className="titre-container">
            <h2 className='titre_entete'>LNE - Ndjamena</h2>
          </div>
          <h3 className='sous_titre_entete'>
            {serviceSelectionne ? `Journal ${serviceSelectionne}` : 'Tasks par Service'} ({donneesFiltrees.length} enregistrement(s))

          </h3>

        </div>
      </div>
      {/* Pied de page */}
      <div className='ftt__footer'>
        <button className="bouton-retour" onClick={retour}>
          Retour  <br></br> ← 
        </button>
        <button className="glow-on-hover MenuBtn" onClick={() => afficherDonneesService('consultation')}>
          Journal Consultation
        </button>
        <button className="glow-on-hover MenuBtn" onClick={() => afficherDonneesService('laboratoire')}>
          Journal Laboratoire
        </button>
        <button className="glow-on-hover MenuBtn" onClick={() => afficherDonneesService('echographie')}>
          Journal Échographie
        </button>
        <button className="glow-on-hover MenuBtn" onClick={() => afficherDonneesService('hospitalisation')}>
          Journal Hospitalisation
        </button>
        <button className="glow-on-hover MenuBtn" onClick={() => afficherDonneesService('chirurgie')}>
          Journal Chirurgie
        </button>
        <button className="glow-on-hover MenuBtn" onClick={() => afficherDonneesService('kinesitherapie')}>
          Journal Kinésithérapie
        </button>
        <button className="glow-on-hover MenuBtn" onClick={() => afficherDonneesService('fibroscopie')}>
          Journal Fibroscopie
        </button>

        <button
          className="glow-on-hover bouton-export"
          onClick={() => creerFichierJSON(serviceSelectionne)}
        >
          📥 Exporter JSON
        </button>
      </div>
      {/* Contenu principal */}
      <div className="contenu-principal">
        {chargement && <div className="chargement">Chargement des données...</div>}
        {erreur && <div className="erreur">Erreur: {erreur}</div>}

        {!chargement && !erreur && !serviceSelectionne && (
          <div className="journal-selection">
            <h3>Sélectionnez un service pour afficher son journal</h3>
          </div>
        )}

        {serviceSelectionne && (
          <div className="journal-donnees">

            {donneesFiltrees.length > 0 ? (
              <TableComponent
                data={donneesFiltrees}
                serviceType={serviceSelectionne}
              />
            ) : (
              <div className="aucune-donnee">
                Aucune donnée trouvée pour le service {serviceSelectionne}
              </div>
            )}
          </div>
        )}
      </div>


    </>
  );
};

export default MgTasks;
